import cn from "classnames";
import React from "react";
import Template from "./template";

export default class FileField extends Template {
    setValue = () => {
        const { inputProps, onChange } = this.props;
        if (onChange) {
            return onChange({ name: inputProps.name, value: this.inputEl.files[0] });
        }
    };

    renderField = () => {
        const { inputProps, value, disabled, index, order, accept } = this.props;
        const tabIndex = this.context?.baseTabIndex || 0;
        const name = index === undefined ? inputProps.name : `${inputProps.name}_${index}`;
        const textValue = value?.name ?? value?.originalFileName ?? "";

        return (
            <label className="input-group input-group-sm cursor-pointer">
                <div className="input-group-prepend">
                    <div className="input-group-text">
                        <i className="icon-uEA0A-file icon-inline" />
                    </div>
                </div>
                <input
                    name={name}
                    ref={(e) => (this.inputEl = e)}
                    type="file"
                    onChange={this.setValue}
                    className="d-none"
                    aria-describedby={`file-input-${name}`}
                    accept={accept}
                />

                <input
                    type="text"
                    key={textValue}
                    defaultValue={textValue}
                    className={cn("form-control form-control-sm", inputProps.className)}
                    onClick={() => this.inputEl?.click()}
                    disabled={disabled || inputProps.disabled}
                    readOnly={inputProps.readOnly}
                    tabIndex={order === undefined ? tabIndex : order + tabIndex}
                />
            </label>
        );
    };
}
